import { createStore } from './create-store';

export type TImportExportType = 'all' | 'import' | 'export';

export interface IWhInfoFilter {
  warehouseId?: number;
  importExportType?: TImportExportType;
}

type TState = {
  filters?: IWhInfoFilter;
};

type TActions = {
  setFilters: (value: IWhInfoFilter | undefined) => void;
};

export const useWhInfoFiltersStore = createStore<TState & TActions>(
  (set) => ({
    filters: undefined,
    setFilters: (filters: IWhInfoFilter | undefined) => set((state) => ({ ...state, filters })),
  }),
  'wh-info-filters-store',
);
